import React, {useEffect, useState} from "react";
import image10 from "../../../../assets/images/blog11-10.png";
import BlogImagePopper from "./BlogImageLarge";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import image27 from "../../../../assets/images/blog11-27.png";
import image16 from "../../../../assets/images/blog11-16.png";
import image9 from "../../../../assets/images/blog11-9.png";
import image26 from "../../../../assets/images/blog11-26.png";
import image8 from "../../../../assets/images/blog11-8.png";
import image24 from "../../../../assets/images/blog11-24.png";
import image20 from "../../../../assets/images/blog11-20.png";
const Blog11 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  useEffect(() => {
    if (selectedImage) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [selectedImage]);
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook:24th March, 2025</h2>
      </div>
      <div className="blogContentnew">
        <p
          style={{
            textAlign: "justify",
            fontFamily: "var(--header-font-family)",
            fontSize: "30px",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "30px",
            color: "#010310",
          }}
        >
          Recession Watch, Fed Put, and the Next Trade War Moves
        </p>
        <div className="subHeader">
          <p className="highlightedBoldText">Setting the Stage</p>
          <div className="contentDivWrapper">
            <div className="contentDiv">
              <p>
                The dust has settled from the Great March Option Expiry, leaving the S&P 500 hovering between 5600-5700. The extreme put-buying pressure has faded, and the market’s next move hinges on
                whether a recession is imminent—or if we’re in for a classic “sell-the-fear, buy-the-reality” rally.
              </p>
              <p>
                With central bank decisions mostly out of the way and a relatively light data calendar this week, will markets attempt a push toward their 200-day moving averages before April’s tariff
                drama unfolds?
              </p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <p className="highlightedBoldText">Key Market Themes</p>
          <div className="subHeader">
            <div className="contentDivWrapper row_reverse">
              <div className="contentDiv">
                <p className="highlightedText_header">Recession Probability and the Fed Put</p>
                <p>
                  Markets are currently pricing in a 30-40% chance of a U.S. recession, reflecting tariff-driven earnings headwinds and a cautious consumer. However, Powell’s recent pivot has
                  rekindled hopes of a Fed safety net. Despite inflation concerns, the Fed appears willing to provide liquidity, effectively reinstating an implicit “Fed Put.”
                </p>
              </div>
              <div className="relatedImg">
                <img
                  src={image10}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image10)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="subHeader">
          <div className="contentDivWrapper ">
            <div className="contentDiv">
              <p className="highlightedText_header">Global Trade Tensions – April 2nd Looms Large</p>
              <p>
                With April 2nd marking a critical tariff deadline, traders are bracing for the impact. While pharma and autos are expected to take a hit, reciprocal tariff threats may not be as severe
                as initially feared. The EU will likely drag its feet, while China remains a wildcard—potentially resolving issues faster than expected.
              </p>
            </div>
            <div className="relatedImg">
              <img
                src={image27}
                alt=""
              />
              <div
                className="zoomBtn"
                onClick={() => handleLargeImg(image27)}
              >
                <button>
                  <img
                    src={zoomImg}
                    alt=""
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="subHeader">
          <div className="contentDivWrapper row_reverse">
            <div className="contentDiv">
              <p className="highlightedText_header">The Gold Rush – More Than Just a Safe Haven?</p>
              <p>
                Gold’s meteoric rise continues, but is it a speculative bubble or a fundamental shift? With physical repatriation accelerating and Utah pushing a gold-based legal tender, some see this
                as a precursor to monetizing U.S. gold reserves.
              </p>
            </div>
            <div className="relatedImg">
              <img
                src={image16}
                alt=""
              />
              <div
                className="zoomBtn"
                onClick={() => handleLargeImg(image16)}
              >
                <button>
                  <img
                    src={zoomImg}
                    alt=""
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <p className="highlightedBoldText">Technical & Sentiment Analysis</p>
          <div className="subHeader">
            <div className="contentDivWrapper ">
              <div className="contentDiv">
                <p className="highlightedText_header">S&P 500 (SPX):</p>
                <p>
                  The index remains range-bound between 5550 and 5700, with options positioning into expiry pinning it short-term near 5650. Sentiment is improving, but caution remains—watch for a
                  potential double-bottom or one last shakeout before a sustained move higher.
                </p>
              </div>
              <div className="relatedImg">
                <img
                  src={image9}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image9)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="subHeader">
            <div className="contentDivWrapper row_reverse">
              <div className="contentDiv">
                <p className="highlightedText_header">Bitcoin & Gold:</p>
                <p>
                  Bitcoin remains highly volatile, while gold is flashing overbought signals. A short-term pullback could be in play before the next leg higher. Large BTC sell trades were in play last
                  week
                </p>
              </div>
              <div className="relatedImg">
                <img
                  src={image26}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image26)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap listWithImage">
              <div className="listImgWrapper">
                <p className="highlightedBoldText">Last Week’s Recap</p>

                <ul className="pointersSection">
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">FOMC Meeting:</span>Powell reinforced the idea of “transitory” inflation concerns, keeping two rate cuts on the table while balancing downside
                      growth risks. Global monetary conditions remain loose
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">Geopolitical Uncertainty:</span>Trade tensions and military conflicts added volatility, but markets held firm.
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">Corporate Earnings:</span> Nike, FedEx, and Micron disappointed, while AI-driven tech stocks saw mixed reactions.
                    </p>
                  </li>
                </ul>
              </div>
              <div className="relatedImg">
                <img
                  src={image8}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image8)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap listWithImage_two">
              <div className="listImgWrapper">
                <p className="highlightedBoldText">The Week Ahead – Key Events to Watch</p>
                <ul className="pointersSection">
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">UK Spring Budget (March 26th): </span>Will fiscal policy pivot toward stimulus or restraint?
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">U.S. PCE Inflation Data (March 29th):</span>A major input for the Fed’s policy path.
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">Japanese Tokyo CPI (March 29th):</span> A crucial read on inflation trends.
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">Earnings Reports:</span>Target, Lululemon, and Porsche headline a lighter earnings week.
                    </p>
                  </li>
                </ul>
              </div>
              <div className="relatedImg">
                <img
                  src={image24}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image24)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap listWithImage">
              <div className="listImgWrapper">
                <p className="highlightedBoldText">Actionable Takeaways</p>

                <ul className="pointersSection">
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">SPX Range Play:</span>5550-5700 remains the near-term battleground. Watch for a breakout or final washout.
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">Gold Caution:</span>While bullish long-term, a pullback toward 2800-2850 wouldn’t be surprising. Dollar strength near-term could signal a pause
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">Silver Lining:</span> When the next Gold breakout starts expect Silver to surge in its seasonally strong period
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">Recession Probability: </span> A 30-40% chance is significant, but not a certainty—stay flexible with positioning as likely large move either
                      way
                    </p>
                  </li>
                </ul>
              </div>
              <div className="relatedImg">
                <img
                  src={image20}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image20)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap listWithImage_two">
              <div className="listImgWrapper">
                <p className="highlightedBoldText">Key Trades to Watch</p>
                <ul className="pointersSection">
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">Long SPX (Breakout Above 5700) </span> – If we clear resistance with strong breadth.
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">Short Gold (Pullback Below 2900) </span>– A potential consolidation play before another leg higher.
                      <span className="highlightedText">Long Silver after another downleg into 32-32.5 zone</span>
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">Japanese Tokyo CPI (March 29th):</span> A crucial read on inflation trends.
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">Long Select AI & Defense Stocks</span>T– Beneficiaries of trade tensions and government spending.
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <p>Stay sharp—volatility isn’t done with us yet. Good luck out there! 🚀</p>
        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/1A41CTeDk8LKdcTxuyO5YwkdYyfSnGwLZL0l-5DynMoA/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog11;
